import { css } from '@emotion/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { AdditionalInfoFormFields } from '@/booking/validators/additional-info-form.validator';
import { Box, Flex } from '@/box';
import { useTranslation } from '@/i18n';
import { Checkbox } from '@/ui/form';
import { Spacer } from '@/ui/spacing';
import { useTheme } from '@/ui/theme';
import { BodySmall, Heading } from '@/ui/typography';

export const AccessibleRoomCheckbox = () => {
  const { t } = useTranslation('additionalInformation');
  const { forms } = useTheme();

  const { register, watch } =
    useFormContext<Pick<AdditionalInfoFormFields, 'accessRequirements'>>();

  const accessRequirements = watch('accessRequirements');

  return (
    <div>
      <Heading
        as="h6"
        style="heading6"
        css={css({
          ...forms.heading,
          ['@media all and (max-width: 730px)']: forms.heading?.mobile,
        })}
      >
        {t('accessibleRoom.title')}
      </Heading>
      <Spacer s="xs" />
      <Flex>
        <Box width={[1 / 2, 150]}>
          <Checkbox
            isChecked={accessRequirements.length > 0}
            label={t('accessibleRoom.label')}
            aria-label={t('accessibleRoom.title')}
            {...register('accessRequirements')}
          />
        </Box>
      </Flex>
      <div>
        {accessRequirements.length > 0 && (
          <BodySmall opacity={0.72} aria-live="polite" role="alert">
            <Spacer s="xxs" />
            {t('accessibleRoom.affirmativeMessage')}
          </BodySmall>
        )}
      </div>
    </div>
  );
};

export default AccessibleRoomCheckbox;
